import type { DetectEnvironmentSourcesOptions } from '@zektec/environment-utils';

export type FrontendEnvironmentSources = DetectEnvironmentSourcesOptions;

export function frontendEnvironmentSources(
  input: {
    apiBaseUrl?: string | URL | null | undefined;
    environmentName?: string | null | undefined;
    identityServiceUrl?: string | URL | null | undefined;
    siteUrl?: string | URL | null | undefined;
  } = {},
): FrontendEnvironmentSources {
  return {
    mode: input.environmentName ?? undefined,
    origins: [input.siteUrl, input.apiBaseUrl, input.identityServiceUrl].map(
      (origin) => origin?.toString(),
    ),
    productionHostIndicators: ['tovplus.com', 'tov.plus'],
    stagingIndicators: ['stage', 'staging', 'release-stage-', '.stage.'],
    localHostIndicators: [
      'localhost',
      '127.0.0.1',
      '0.0.0.0',
      '::1',
      '.tovplus.local',
    ],
  };
}
